module.exports = {
	"ha": "bc",
	"id": 5.5,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2018 Q3–2020 Q2",
		"lastYear": "2020",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Age Category and MSM Status, Year Ending 2020 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 94.11764705882352,
						"dataLabels": {
							"enabled": false,
							"format": "160"
						},
						"color": "#043f61"
					},
					{
						"y": 83.52941176470588,
						"dataLabels": {
							"enabled": false,
							"format": "142"
						},
						"color": "#0c4250"
					},
					{
						"y": 78.23529411764706,
						"dataLabels": {
							"enabled": false,
							"format": "133"
						},
						"color": "#0d4440"
					},
					{
						"y": 66.47058823529412,
						"dataLabels": {
							"enabled": false,
							"format": "113"
						},
						"color": "#09472e"
					},
					{
						"y": 51.17647058823529,
						"dataLabels": {
							"enabled": false,
							"format": "87"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.53521126760563,
						"dataLabels": {
							"enabled": false,
							"format": "554"
						},
						"color": "#043f61"
					},
					{
						"y": 82.04225352112677,
						"dataLabels": {
							"enabled": false,
							"format": "466"
						},
						"color": "#0c4250"
					},
					{
						"y": 77.46478873239437,
						"dataLabels": {
							"enabled": false,
							"format": "440"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.47887323943662,
						"dataLabels": {
							"enabled": false,
							"format": "406"
						},
						"color": "#09472e"
					},
					{
						"y": 57.570422535211264,
						"dataLabels": {
							"enabled": false,
							"format": "327"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.185667752443,
						"dataLabels": {
							"enabled": false,
							"format": "609"
						},
						"color": "#043f61"
					},
					{
						"y": 89.25081433224756,
						"dataLabels": {
							"enabled": false,
							"format": "548"
						},
						"color": "#0c4250"
					},
					{
						"y": 83.06188925081433,
						"dataLabels": {
							"enabled": false,
							"format": "510"
						},
						"color": "#0d4440"
					},
					{
						"y": 75.8957654723127,
						"dataLabels": {
							"enabled": false,
							"format": "466"
						},
						"color": "#09472e"
					},
					{
						"y": 58.95765472312704,
						"dataLabels": {
							"enabled": false,
							"format": "362"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "2450"
						},
						"color": "#043f61"
					},
					{
						"y": 91.22448979591836,
						"dataLabels": {
							"enabled": false,
							"format": "2235"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.08163265306122,
						"dataLabels": {
							"enabled": false,
							"format": "2109"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.10204081632652,
						"dataLabels": {
							"enabled": false,
							"format": "2036"
						},
						"color": "#09472e"
					},
					{
						"y": 66.44897959183673,
						"dataLabels": {
							"enabled": false,
							"format": "1628"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "68"
						},
						"color": "#043f61"
					},
					{
						"y": 85.29411764705883,
						"dataLabels": {
							"enabled": false,
							"format": "58"
						},
						"color": "#0c4250"
					},
					{
						"y": 77.94117647058823,
						"dataLabels": {
							"enabled": false,
							"format": "53"
						},
						"color": "#0d4440"
					},
					{
						"y": 67.64705882352942,
						"dataLabels": {
							"enabled": false,
							"format": "46"
						},
						"color": "#09472e"
					},
					{
						"y": 42.64705882352941,
						"dataLabels": {
							"enabled": false,
							"format": "29"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.00332225913621,
						"dataLabels": {
							"enabled": false,
							"format": "298"
						},
						"color": "#043f61"
					},
					{
						"y": 91.0299003322259,
						"dataLabels": {
							"enabled": false,
							"format": "274"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.38205980066445,
						"dataLabels": {
							"enabled": false,
							"format": "257"
						},
						"color": "#0d4440"
					},
					{
						"y": 68.77076411960132,
						"dataLabels": {
							"enabled": false,
							"format": "207"
						},
						"color": "#09472e"
					},
					{
						"y": 43.18936877076412,
						"dataLabels": {
							"enabled": false,
							"format": "130"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.26253687315634,
						"dataLabels": {
							"enabled": false,
							"format": "673"
						},
						"color": "#043f61"
					},
					{
						"y": 88.20058997050147,
						"dataLabels": {
							"enabled": false,
							"format": "598"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.89085545722715,
						"dataLabels": {
							"enabled": false,
							"format": "562"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.82890855457227,
						"dataLabels": {
							"enabled": false,
							"format": "487"
						},
						"color": "#09472e"
					},
					{
						"y": 43.067846607669615,
						"dataLabels": {
							"enabled": false,
							"format": "292"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.65616045845273,
						"dataLabels": {
							"enabled": false,
							"format": "1739"
						},
						"color": "#043f61"
					},
					{
						"y": 89.45558739255014,
						"dataLabels": {
							"enabled": false,
							"format": "1561"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.5272206303725,
						"dataLabels": {
							"enabled": false,
							"format": "1475"
						},
						"color": "#0d4440"
					},
					{
						"y": 78.16618911174785,
						"dataLabels": {
							"enabled": false,
							"format": "1364"
						},
						"color": "#09472e"
					},
					{
						"y": 55.41547277936962,
						"dataLabels": {
							"enabled": false,
							"format": "967"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 48.161764705882355,
						"dataLabels": {
							"enabled": false,
							"format": "131"
						},
						"color": "#043f61"
					},
					{
						"y": 40.44117647058824,
						"dataLabels": {
							"enabled": false,
							"format": "110"
						},
						"color": "#0c4250"
					},
					{
						"y": 36.76470588235294,
						"dataLabels": {
							"enabled": false,
							"format": "100"
						},
						"color": "#0d4440"
					},
					{
						"y": 31.985294117647058,
						"dataLabels": {
							"enabled": false,
							"format": "87"
						},
						"color": "#09472e"
					},
					{
						"y": 16.544117647058822,
						"dataLabels": {
							"enabled": false,
							"format": "45"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 88.32116788321169,
						"dataLabels": {
							"enabled": false,
							"format": "363"
						},
						"color": "#043f61"
					},
					{
						"y": 69.58637469586375,
						"dataLabels": {
							"enabled": false,
							"format": "286"
						},
						"color": "#0c4250"
					},
					{
						"y": 64.72019464720195,
						"dataLabels": {
							"enabled": false,
							"format": "266"
						},
						"color": "#0d4440"
					},
					{
						"y": 59.854014598540154,
						"dataLabels": {
							"enabled": false,
							"format": "246"
						},
						"color": "#09472e"
					},
					{
						"y": 43.30900243309003,
						"dataLabels": {
							"enabled": false,
							"format": "178"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 87.74271844660194,
						"dataLabels": {
							"enabled": false,
							"format": "723"
						},
						"color": "#043f61"
					},
					{
						"y": 62.74271844660194,
						"dataLabels": {
							"enabled": false,
							"format": "517"
						},
						"color": "#0c4250"
					},
					{
						"y": 56.189320388349515,
						"dataLabels": {
							"enabled": false,
							"format": "463"
						},
						"color": "#0d4440"
					},
					{
						"y": 52.06310679611651,
						"dataLabels": {
							"enabled": false,
							"format": "429"
						},
						"color": "#09472e"
					},
					{
						"y": 37.62135922330097,
						"dataLabels": {
							"enabled": false,
							"format": "310"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 85.98130841121495,
						"dataLabels": {
							"enabled": false,
							"format": "2024"
						},
						"color": "#043f61"
					},
					{
						"y": 55.56499575191164,
						"dataLabels": {
							"enabled": false,
							"format": "1308"
						},
						"color": "#0c4250"
					},
					{
						"y": 50.637213254035686,
						"dataLabels": {
							"enabled": false,
							"format": "1192"
						},
						"color": "#0d4440"
					},
					{
						"y": 48.598130841121495,
						"dataLabels": {
							"enabled": false,
							"format": "1144"
						},
						"color": "#09472e"
					},
					{
						"y": 36.74596431605777,
						"dataLabels": {
							"enabled": false,
							"format": "865"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -5.882352941176472,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.250000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.338028169014088,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.037593984962406,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.008849557522126,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.464788732394363,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.884476534296033,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.579399141630903,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.727272727272727,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.458128078817737,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.8143322475570036,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.016420361247945,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.934306569343063,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.62745098039216,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.3175965665236,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.775510204081638,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.637583892617448,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.4613560929350418,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.039292730844792,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.70588235294118,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.62068965517241,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.207547169811317,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -36.95652173913043,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.9966777408637828,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.053691275167784,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.204379562043794,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.455252918287936,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -37.19806763285024,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.7374631268436627,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.144130757800896,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.020066889632103,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.345195729537362,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -40.04106776180698,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.34383954154727503,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.235767682576192,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.509288917360666,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.525423728813562,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -29.105571847507328,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -51.83823529411764,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.030534351145043,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -48.275862068965516,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -11.678832116788318,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.212121212121215,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.99300699300699,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.518796992481203,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.642276422764223,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -12.257281553398059,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.492392807745503,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.444874274661508,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.343412526997839,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.738927738927742,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -14.018691588785048,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.37549407114624,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.868501529051986,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.026845637583898,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.388111888111887,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=170"
			},
			{
				"x": 9,
				"text": "30-39<br>n=568"
			},
			{
				"x": 15,
				"text": "40-49<br>n=614"
			},
			{
				"x": 21,
				"text": ">=50<br>n=2450"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=68"
			},
			{
				"x": 34,
				"text": "30-39<br>n=301"
			},
			{
				"x": 40,
				"text": "40-49<br>n=678"
			},
			{
				"x": 46,
				"text": ">=50<br>n=1745"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=272"
			},
			{
				"x": 59,
				"text": "30-39<br>n=411"
			},
			{
				"x": 65,
				"text": "40-49<br>n=824"
			},
			{
				"x": 71,
				"text": ">=50<br>n=2354"
			}
		],
		"dataTable": {
			"MSM:<30": [
				170,
				160,
				142,
				133,
				113,
				87
			],
			"MSM:30-39": [
				568,
				554,
				466,
				440,
				406,
				327
			],
			"MSM:40-49": [
				614,
				609,
				548,
				510,
				466,
				362
			],
			"MSM:>=50": [
				2450,
				2450,
				2235,
				2109,
				2036,
				1628
			],
			"Non-MSM:<30": [
				68,
				68,
				58,
				53,
				46,
				29
			],
			"Non-MSM:30-39": [
				301,
				298,
				274,
				257,
				207,
				130
			],
			"Non-MSM:40-49": [
				678,
				673,
				598,
				562,
				487,
				292
			],
			"Non-MSM:>=50": [
				1745,
				1739,
				1561,
				1475,
				1364,
				967
			],
			"Unknown:<30": [
				272,
				131,
				110,
				100,
				87,
				45
			],
			"Unknown:30-39": [
				411,
				363,
				286,
				266,
				246,
				178
			],
			"Unknown:40-49": [
				824,
				723,
				517,
				463,
				429,
				310
			],
			"Unknown:>=50": [
				2354,
				2024,
				1308,
				1192,
				1144,
				865
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_5.json
// module id = 170
// module chunks = 0